export const fetchRemovePayment = (guid, callback) => {
    fetch(helpable.replaceUrlParameters(routable.getRoute('removePayment'), { _guid_: guid }), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then(async (data) => {
            await callback(data);
        })
        .catch(() => {
            // TODO resolve catch
        });
};

export const fetchEditPayment = (
    guid,
    formData,
    callback,
    errorCallback = () => {},
    isBetween = false
) => {
    const url =
        isBetween === false
            ? helpable.replaceUrlParameters(routable.getRoute('editPayment'), { _guid_: guid })
            : routable.getRoute('companyPaymentIntegrationTransferReact');
    fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then(async (data) => {
            if (data.errors) {
                loader.hide();
                errorCallback(data);
            } else {
                await callback(data);
            }
        })
        .catch(() => {
            // TODO resolve catch
        });
};

export const fetchAddPayment = (url, formData, callback) => {
    fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            callback(data);
        })
        .catch(() => {
            // TODO resolve catch
        });
};

export const fetchCreatePartner = (formData, callback) => {
    fetch(routable.getRoute('createCompanyPartner'), {
        method: 'POST',
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            callback(data);
        })
        .catch(() => {
            // TODO resolve catch
        });
};

export const fetchSyncIntegration = (callback, errorCallback) => {
    fetch(routable.getRoute('syncIntegration'), {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            if (data.status === 'error') {
                loader.hide();
                errorCallback(data);
            } else {
                callback(data);
            }
        })
        .catch(() => {
            // TODO resolve catch
        });
};
